import numeral from 'numeral';

export const formatCurrency = (
  value: number | string | null | undefined,
  showMinus?: boolean,
  showMoney: boolean = true
): string => {
  const formatString = showMoney ? '$0,0.00' : '0,0.00';

  if (showMinus && Number(value) < 0) {
    return `- ${numeral(value || 0).format(formatString)}`;
  }

  return numeral(value || 0).format(formatString);
};

export const formatNumber = (value: number | string | null | undefined): string => {
  return numeral(value || 0).format('0,0');
};
